import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';
import { useFormikContext } from 'formik';
import { FormValues } from '../NewTemplate';
import { industries, Industry, IndustryId } from '@/constants/industries';

const MENU_TYPES = [
  {
    id: 'web',
    label: 'Web',
  },
  {
    id: 'menu',
    label: 'Menu',
  },
  {
    id: 'landing-page',
    label: 'Landing Page',
  },
]

const Details = () => {
  const { values, handleChange, setFieldValue } = useFormikContext<FormValues>();

  const handleCheckboxes = (e: {
    target : {
      name: string;
      checked: boolean;
      value: string;
    }
  }) => {
    const name = e.target.name as 'type' | 'industry';
    const value = e.target.value as IndustryId;

    if (name === 'industry') {
      const draft = values?.[name] ?? [];
      const index = draft.findIndex(industry => industry === value);
  
      if (index >= 0) {
        draft.splice(index, 1);
      } else {
        draft.push(value);
      }
  
      setFieldValue(name, draft);
      return;
    }

    setFieldValue(name, value);
  }

  return (
    <Stack spacing={2} flex={1}>
      <TextField
        label="Título"
        fullWidth
        margin="normal"
        name="title"
        value={values?.title ?? ''}
        onChange={handleChange}
      />
      <TextField
        label="Imagen"
        fullWidth
        margin="normal"
        name="image"
        value={values?.image ?? ''}
        onChange={handleChange}
      />
      <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
        <FormLabel component="legend">Industria</FormLabel>
        <FormGroup>
          {Object.values(industries).map((industry: Industry) => (
            <FormControlLabel
              key={industry.id}
              label={industry.locale.es}
              control={
                <Checkbox
                  name="industry"
                  value={industry.id}
                  onChange={handleCheckboxes}
                  checked={(values?.industry ?? []).includes(industry.id)}
                />
              }
            />
          ))}
        </FormGroup>
      </FormControl>
      <FormControl
        sx={{ m: 3 }}
        component="fieldset"
        variant="standard"
      >
        <FormLabel component="legend">Tipo</FormLabel>
        <FormGroup>
          {MENU_TYPES.map(({ id, label }) => (
              <FormControlLabel
                label={label}
                key={id}
                control={
                  <Checkbox
                    name="type"
                    value={id}
                    onChange={handleCheckboxes}
                    checked={values?.type === id}
                  />
                }
              />
          ))}
        </FormGroup>
      </FormControl>
    </Stack>
  );
};

export default Details;
